<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle class="bar"
  style="background-color: #d7e3ff;color: black;">
  <mat-icon class="barIcon">
    {{icon}} </mat-icon>
  {{title}}
  <button mat-icon-button matTooltip="Cerrar" class="closeButton" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>